<div class="confirm-dialog">
  <div class="header">
    <mat-icon class="icon" aria-hidden="true">{{ iconToShow }}</mat-icon>
    <div class="titles">
      <h2 class="title">{{ data.title || 'Confirmación' }}</h2>
    </div>
  </div>

  <div class="body">
    <p class="message">{{ data.message }}</p>
  </div>

  <div class="actions">
    <button mat-stroked-button (click)="onCancel()" aria-label="Cancelar">
      {{ data.cancelText || 'Cancelar' }}
    </button>
    <button
      mat-flat-button
      [color]="data.variant === 'danger' ? 'warn' : 'primary'"
      (click)="onConfirm()"
      aria-label="Confirmar"
    >
      {{ data.confirmText || 'Confirmar' }}
    </button>
  </div>
</div>
